import React from 'react'
import EmbedNode from '../EmbedNode'
import {useEnv} from '../../../hooks/useEnv'

export default function FigmaNode({id,data,selected,...props}) {
    const {getBaseUrl}=useEnv()
    return (
        <EmbedNode domain='figma.com' transformUrl={(url) => {return url.includes('embed')? url:`https://www.figma.com/embed?embed_host=flowsage&url=${(url)}`}} className='' text='Figma Project Link' id={id} data={data} selected={selected} {...props} />
    )
}